"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _Captcha = _interopRequireDefault(require("@/components/Captcha"));
var _ServerSelector = _interopRequireDefault(require("./ServerSelector"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = exports.default = {
  components: {
    ServerSelector: _ServerSelector.default,
    Captcha: _Captcha.default
  },
  props: ['network'],
  data() {
    return {
      server_type: 'network',
      znc_username: '',
      znc_network: '',
      znc_password: '',
      show_advanced: false,
      switch_tabs_on_connect: false,
      network_list: []
    };
  },
  computed: {
    startupOptions() {
      return this.$state.getSetting('settings.startupOptions');
    },
    settingShowRaw: {
      get() {
        return this.network.setting('show_raw');
      },
      set(val) {
        return this.network.setting('show_raw', val);
      }
    },
    directWs: {
      get() {
        if (!this.network.connection.direct) {
          return '';
        }
        let connection = this.network.connection;
        let addr = '';
        addr += connection.tls ? 'wss://' : 'ws://';
        addr += connection.server;
        let port = parseInt(connection.port, 10);
        if (Number.isNaN(port)) {
          port = connection.tls ? 443 : 80;
        }

        // Only include the port if needed
        if (connection.tls && port !== 443 || !connection.tls && port !== 80) {
          addr += ':' + connection.port;
        }
        addr += connection.path;
        return addr;
      },
      set(newVal) {
        let url = null;
        try {
          url = new URL(newVal);
        } catch (e) {
          return;
        }
        let connection = this.network.connection;
        connection.tls = url.protocol.toLowerCase() === 'wss:';
        connection.server = url.hostname;
        let port = parseInt(url.port, 10);
        if (Number.isNaN(port)) {
          port = url.protocol.toLowerCase() === 'wss:' ? 443 : 80;
        }
        connection.port = port;
        let u = url.href.replace(url.protocol + '//', '');
        connection.path = u.substr(u.indexOf('/'));
      }
    }
  },
  watch: {
    znc_username() {
      this.setZncPass();
    },
    znc_network() {
      this.setZncPass();
    },
    znc_password() {
      this.setZncPass();
    },
    'network.state'() {
      if (!this.switch_tabs_on_connect) {
        return;
      }
      if (this.network.state === 'connected') {
        this.switch_tabs_on_connect = false;
        this.$state.$emit('server.tab.show', 'messages');
      } else if (this.network.state_error) {
        this.switch_tabs_on_connect = false;
      }
    }
  },
  created() {
    let isZnc = !!(this.network.connection.password || '').match(/^(.*)\/(.*):(.*)$/);
    this.server_type = isZnc ? 'znc' : 'network';
    if (isZnc) {
      let match = (this.network.connection.password || '').match(/^(.*)\/(.*):(.*)$/);
      this.znc_username = match[1] || '';
      this.znc_network = match[2] || '';
      this.znc_password = match[3] || '';
    }
    this.network_list = this.$state.setting('presetNetworks') || [];
  },
  methods: {
    readableStateError(err) {
      return Misc.networkErrorMessage(err);
    },
    connect() {
      if (this.network.state !== 'disconnected') {
        return;
      }
      this.switch_tabs_on_connect = true;
      this.network.ircClient.connect();
    },
    disconnect() {
      if (this.network.state === 'disconnected') {
        return;
      }
      this.network.ircClient.quit(this.$state.setting('quitMessage') || 'Client Closed Connection');
    },
    removeNetwork() {
      /* eslint-disable no-restricted-globals, no-alert */
      let confirmed = confirm('Really remove this network? This cannot be undone!');
      if (!confirmed) {
        return;
      }
      this.$state.removeNetwork(this.network.id);
      this.$state.$emit('active.component');
    },
    setZncPass() {
      let newPass = `${this.znc_username}/${this.znc_network}:${this.znc_password}`;
      this.network.connection.password = newPass;
    },
    toggleTls() {
      let connection = this.network.connection;
      connection.tls = !connection.tls;

      // Switching the port only if were currently using the most common TLS/plain text ports
      if (connection.tls && connection.port === 6667) {
        connection.port = 6697;
      } else if (!connection.tls && connection.port === 6697) {
        connection.port = 6667;
      }
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["NetworkSettings"]
window._kiwi_exports.components.NetworkSettings = exports.default ? exports.default : exports;
